import createCrud from '../../crud';

import { UPDATE_LIST_ITEM } from 'vx/mutations'

export default createCrud({
    resource: 'items',
    state : {
      filters: {
        status: null,
        users: []
      }
    },
    getters: {
      getByStoryIdAndStatus: (state) => (id, status) => {
        return state.list.filter(task => {
          if (Array.isArray(status)) {
            return task.story_id === id && status.map(obj => obj.toLowerCase()).includes(task.status.toLowerCase())
          } else {
            return task.story_id === id && task.status.toLowerCase() === status.toLowerCase();
          }
        }).sort((a, b) => {
          return a.last_drag - b.last_drag
        })
      },
      getByStatusAndFilters: (state) => (status) => {
        return state.list.filter(task => {
          if (Array.isArray(status)) {
            return status.map(obj => obj.toLowerCase()).includes(task.status.toLowerCase())
          } else {
            return task.status.toLowerCase() === status.toLowerCase();
          }
        }).sort((a, b) => {
          return a.last_drag - b.last_drag
        })
      },
      getByFilters: (state) => () => {

        return state.list.filter(task => {

          //Only show tasks that match the filter status selcted
          if (state.filters.status !== null && task.status !== state.filters.status) return false


          //Only show tasks that match the filter status users
          if (state.filters.users.length && !state.filters.users.map((user) => { return user.id}).includes(task.owner_id)) return false

          return true
        })
      },
      getCountOfStatus: (state) => (storyIds, status) => {
        return state.list.filter(task => {
          return storyIds.includes(task.story_id) && task.status === status;
        }).length
      },
      getCountOfStatusAndStoryId: (state) => (status, story_id) => {
        return state.list.filter(task => {
          return task.status === status && task.story_id === story_id;
        }).length
      }
    },
    actions: {
      updateIfLatestVersion({ commit, getters }, item) {

      let stateItem = getters.getById(item.id);

      if (stateItem !== undefined && item.version >= stateItem.version) {
        commit(UPDATE_LIST_ITEM, [item])
      }
    },
    }
  });
